function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M318 194V91c0-35-28-63-62-63-35 0-62 28-62 63v103H91c-35 0-63 28-63 62 0 35 28 62 63 62h103v103c0 35 28 63 62 63 35 0 62-28 62-63V318h103c35 0 63-28 63-62 0-35-28-62-63-62z"
})));